module.exports = __webpack_public_path__ + "img/GT6.d295815a.png";